import script from "./UsersFilterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersFilterBar.vue?vue&type=script&setup=true&lang=ts"

import "@/components/user/UserFilterBar.css?vue&type=style&index=0&id=47246cc0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47246cc0"]])

export default __exports__